import React, { useState, useEffect } from 'react';


import avatarIcon1 from '../assets/img/avatar-icon1.png';
import avatarIcon2 from '../assets/img/avatar-icon2.png';
import avatarIcon5 from '../assets/img/avatar-icon5.png';
import avatarIcon3 from '../assets/img/avatar-icon3.png';
import avatarIcon4 from '../assets/img/avatar-icon4.webp';

function Testimonial() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStartPos, setTouchStartPos] = useState(0);
  const [touchEndPos, setTouchEndPos] = useState(0);

  const testimonials = [
    {
      name: "Rahul S.",
      avatar: avatarIcon1,
      testimonial:
        "The ambulance service was quick and efficient. They arrived within minutes and provided excellent care during transport. Highly recommended!",
    },
    {
      name: "Anita P.",
      avatar: avatarIcon2, 
      testimonial:
        "Very professional team! The paramedics were well-trained and ensured my father was comfortable throughout the journey. Thank you for your service!",
    },
    {
      name: "Vikram K.",
      avatar: avatarIcon5, 
      testimonial:
        "The fully equipped ambulance and trained staff made a huge difference in a critical situation. Grateful for their prompt response.",
    },
    {
      name: "Pooja M.",
      avatar: avatarIcon3, 
      testimonial:
        "The service was outstanding! They transported my grandmother safely across the city, and the staff was extremely compassionate.",
    },
    {
      name: "Ramesh T.",
      avatar: avatarIcon4, 
      testimonial:
        "Highly reliable ambulance service with fair pricing. They were well-prepared with all necessary medical equipment and responded swiftly.",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 4500);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const handleTouchStart = (e) => {
    setTouchStartPos(e.changedTouches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    setTouchEndPos(e.changedTouches[0].clientX);
    const touchPosDiff = touchStartPos - touchEndPos;

    if (touchPosDiff > 30) {
      handlePrevSlide();
    } else if (touchPosDiff < -30) {
      handleNextSlide();
    }
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <div id="testimonial" className="testimonial">
          <h4 className="fade-out fade-in ">What Our Clients Say</h4>
          <h1 className="fade-out fade-in ">Real Experiences from Our Valued Customers</h1>
          <h6 className="fade-out fade-in ">
            We prioritize trust and efficiency, ensuring top-notch emergency medical services for all.
          </h6>

          <div
            id="testim"
            className="testim fade-out fade-in "
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <div className="wrap">
              <span
                id="right-arrow"
                className="arrow right fa fa-chevron-right fade-out fade-in fade-out-right"
                onClick={handleNextSlide}
              ></span>
              <span
                id="left-arrow"
                className="arrow left fa fa-chevron-left fade-out fade-in fade-out-right"
                onClick={handlePrevSlide}
              ></span>
              <ul id="testim-dots" className="dots fade-out fade-in">
                {testimonials.map((_, index) => (
                  <li
                    key={index}
                    className={`dot ${index === currentSlide ? "active" : ""}`}
                    onClick={() => setCurrentSlide(index)}
                  ></li>
                ))}
              </ul>
              <div id="testim-content" className="cont">
                {testimonials.map((testimonial, index) => (
                  <div key={index} className={index === currentSlide ? "active" : ""}>
                    <div className="img fade-out-right">
                      <img src={testimonial.avatar} alt={testimonial.name} />
                    </div>
                    <h2>{testimonial.name}</h2>
                    <p>{testimonial.testimonial}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
